import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NON_ATTENDANCE_APPLICATIONS } from '@/api/endpoints';
import { NON_ATTENDANCE_APPLICATIONS_QUERY_KEY } from '@/api/queryKeys';
import type {
  NonAttendanceApplicationDetail,
  SubmitNonAttendanceApplicationRequest,
} from '@/components/AbsenceApplication/types';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useSubmitNonAttendanceApplication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SubmitNonAttendanceApplicationRequest) =>
      apiClient
        .post<NonAttendanceApplicationDetail>(
          API_NON_ATTENDANCE_APPLICATIONS,
          payload,
        )
        .then(unwrapAxiosResponse),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: NON_ATTENDANCE_APPLICATIONS_QUERY_KEY,
      });
    },
  });
};
